module.exports = __webpack_public_path__ + "img/smart-scan-char-5.124d2999.png";